import { render, staticRenderFns } from "./UnsubscribeEmployee.vue?vue&type=template&id=00b71c6d&scoped=true&"
import script from "./UnsubscribeEmployee.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeEmployee.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeEmployee.vue?vue&type=style&index=0&id=00b71c6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b71c6d",
  null
  
)

export default component.exports